module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [(_vm.show) ? _c('div', [_c('div', {
    class: {
      'modal-mask': _vm.show_modal_mask
    }
  }, [_c('div', {
    staticClass: "modal-wrapper"
  }, [_c('div', {
    directives: [{
      name: "on-clickaway",
      rawName: "v-on-clickaway",
      value: (_vm.clickAway),
      expression: "clickAway"
    }],
    ref: "modalContent",
    staticClass: "modal-container",
    class: {
      'modal_from_bottom': _vm.modal_from_bottom
    },
    attrs: {
      "tabindex": "-1",
      "role": "dialog",
      "aria-modal": "true",
      "aria-label": _vm.ariaLabel || null
    }
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('div', {
    staticClass: "font-large close-cross",
    attrs: {
      "role": "button",
      "tabindex": "0",
      "aria-label": _vm.$t('vue2.a11y.close')
    },
    on: {
      "click": _vm.removeModal,
      "keydown": [function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        $event.stopPropagation();
        return _vm.removeModal.apply(null, arguments)
      }, function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "space", 32, $event.key, [" ", "Spacebar"])) { return null; }
        $event.preventDefault();
        $event.stopPropagation();
        return _vm.removeModal.apply(null, arguments)
      }]
    }
  }, [_c('span', {
    staticClass: "icon-cross2 pointer",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _vm._t("header", function() {
    return [_vm._v("default header")]
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_vm._t("body", function() {
    return [_vm._v("default body")]
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_vm._t("footer", function() {
    return [_c('button', {
      staticClass: "bttn bttn_simple right marg-10"
    }, [_vm._v("\n                Ok\n\n              ")]), _vm._v(" "), _c('button', {
      staticClass: "bttn bttn_simple right marg-10"
    }, [_vm._v("\n                Gem\n\n              ")])]
  })], 2)])])])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-0b6a9ee6!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Modal.vue
// module id = 1755
// module chunks = 1